import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { fetchCard } from './cardsAPI'

const initialState = {}

export const getCard = createAsyncThunk('cards/getCard', async ({ name, tag }, thunkAPI) => {
  if (thunkAPI.requestId === thunkAPI.getState().cards[name].requestId) {
    const response = await fetchCard(name)
    if (response.code === 403) {
      let nameparts = name.split('|')
      const rename = nameparts[0].split('//')[0].trim()
      if (rename === nameparts[0]) console.log(rename)
      nameparts[0] = rename
      const reresponse = await fetchCard(nameparts.join('|'))
      if (reresponse.code === 403) return thunkAPI.rejectWithValue({ message: reresponse.message })
      return reresponse
    }
    return response
  }
})

export const cardsSlice = createSlice({
  name: 'cards',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCard.pending, (state, action) => {
        state[action.meta.arg.name] = {
          error: '',
          loaded: false,
          pending: true,
          requestId: action.meta.requestId,
          tag: action.meta.arg.tag,
        }
      })
      .addCase(getCard.fulfilled, (state, action) => {
        state[action.meta.arg.name] = {
          ...state[action.meta.arg.name],
          ...action.payload,
          typo: action.meta.arg.name.split('|')[0] !== action.payload.name,
          loaded: true,
          pending: false,
        }
      })
      .addCase(getCard.rejected, (state, action) => {
        state[action.meta.arg.name].error = action.error.message
        state[action.meta.arg.name].pending = false
      })
  },
})

export default cardsSlice.reducer
